import useHostfullyAccountingRedirect from 'hooks/hostfullyAccounting/useHostfullyAccountingRedirect';
import { useTranslation } from 'react-i18next';
import AsyncAccessLink from './AsyncAccessLink';

const AccountingAccessLink = () => {
  const { t } = useTranslation();
  const { isAccountingActive, isFetching, redirectToHostfullyAccounting } =
    useHostfullyAccountingRedirect();

  if (!isAccountingActive) {
    return null;
  }

  return (
    <AsyncAccessLink
      label={t('pageIntegrations.table.hostfullyAccounting')}
      onAccess={redirectToHostfullyAccounting}
      isFetching={isFetching}
    />
  );
};

export default AccountingAccessLink;
